import { useEffect, useRef, useState } from 'react'

import { downloadFileDocumentById } from '../../../api'
import { EMPTY_OBJECT } from '../../../constants/common'
import { useOutboundUuid } from '../../../hooks'
import { isApiAcceptedStatus } from '../../../utils/api'

import { FILE_DOWNLOAD_POLL_INTERVAL } from './useFileDownload.constants'

export function useFileDownload({
  apiParams,
  downloadFileDocument,
  file,
  interval = FILE_DOWNLOAD_POLL_INTERVAL,
  onLoad,
  onSuccess,
} = EMPTY_OBJECT) {
  const [loading, setLoading] = useState(false)

  const outboundUuid = useOutboundUuid()

  async function downloadFileDocumentByIdDefault(id, params) {
    return downloadFileDocumentById({ id, outboundUuid, params })
  }

  const downloadFileDocumentApi =
    downloadFileDocument ?? downloadFileDocumentByIdDefault

  const timerRef = useRef(null)

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current)
    }
  }, [])

  function downloadFile(item = file) {
    const { id, localUrl } = item

    if (loading) {
      return
    }

    if (localUrl) {
      window.open(localUrl)

      return
    }

    setLoading(true)

    downloadFileDocumentApi(id, apiParams)
      .then(response => {
        if (isApiAcceptedStatus(response.status)) {
          timerRef.current = setTimeout(() => downloadFile(item), interval)
        } else {
          setLoading(false)

          if (onLoad) {
            onLoad(response.data)
          } else {
            window.open(response.data)
          }

          onSuccess?.()
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return { downloadFile, loading }
}
